import { Component, Input, ViewChild, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoaderService } from '../../comun/services/loader.service';
import { FuncionesService } from '../../comun/services/funciones.service';
import Swal from 'sweetalert2';
import { PerfilComponent } from '../perfil.component';
import { forkJoin } from 'rxjs';
import { GlobalConstants } from '../../global-constants';
import { QueryService } from '../../comun/services/query.service';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-perfil-edit',
  templateUrl: './perfil-edit.component.html',
  styleUrl: './perfil-edit.component.css'
})
export class PerfilEditComponent {
  @Input() misdatos!: any;
  @Input() perfil!: any;
  @Input() edit!: any;
  @ViewChild('fileInputPrincipal') fileInputPrincipal!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  selectedFiles: any = { imagenes: [], previewUrl: [] };
  principal: string = '';
  previewUrl: string | ArrayBuffer | null = null;  
  busy: number = 0;

  inputBuscador = new FormControl('');
  sugerencias$: Observable<any[]> = of([]);
  mostrarDesplegable = false;

  constructor(private loader: LoaderService,
              private http: HttpClient,
              public funciones: FuncionesService,
              private query: QueryService,
              public app: PerfilComponent) {}

  ngOnInit() {
    this.sugerencias$ = this.inputBuscador.valueChanges.pipe(
      debounceTime(400),        // Espera 400ms después de que el usuario deja de escribir
      distinctUntilChanged(),   // Evita buscar si el texto es idéntico al anterior
      switchMap(texto => {
        if (texto && texto.length > 3) { // Busca solo si hay más de 3 caracteres
          this.mostrarDesplegable = true;
          return this.app.geoService.buscarDireccion(texto).pipe(
            catchError(() => {
              this.mostrarDesplegable = false;
              return of([]); // Si hay error en la API, devuelve array vacío para no romper el flujo
            })
          );
        } else {
          this.mostrarDesplegable = false;
          return of([]);
        }
      })
    );
  }    

  seleccionarDireccion(direccion: any) {
    // Al hacer click, rellenamos el input con el nombre completo
    this.inputBuscador.setValue(direccion.display_name, { emitEvent: false });
    this.mostrarDesplegable = false;

    // Aquí ya tienes las coordenadas exactas de lo que eligió el usuario:
    console.log('Dirección seleccionada:', direccion);
    console.log('Latitud:', direccion.lat, 'Longitud:', direccion.lon);

    this.perfil.direccionfisica = direccion.display_name;
  }

  onClickImagenPrincipal() {
    // Simula el click en el input file
    this.fileInputPrincipal.nativeElement.click();
  }
  onClickImagen() {
    // Simula el click en el input file
    this.fileInput.nativeElement.click();
  }

  onFileSelectedPrincipal(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.loader.show();

      // PREVIEW LOCAL
      const file = input.files[0];

      // Guardar la imagen original sin recortar
      const readerOriginal = new FileReader();
      readerOriginal.onload = () => {
        this.perfil.data = readerOriginal.result; // imagen original
      };
      readerOriginal.readAsDataURL(file);

      this.funciones.recortarImagenCuadrada(file, 500)
        .then((dataUrl) => {
          this.previewUrl = dataUrl;   // preview
          this.loader.hide();
        })
        .catch((err) => {
          console.error(err);
          this.loader.hide();
        });
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.loader.show();

      Array.from(input.files).forEach((file: File) => {
        // Guardar la imagen original sin recortar
        const readerOriginal = new FileReader();
        readerOriginal.onload = () => {
          this.selectedFiles.imagenes.push(readerOriginal.result); // imagen original
        };
        readerOriginal.readAsDataURL(file);

        this.funciones.recortarImagenCuadrada(file, 500)
          .then((dataUrl) => {
            this.selectedFiles.previewUrl.push(dataUrl);   // preview
            this.loader.hide();
          })
          .catch((err) => {
            console.error(err);
            this.loader.hide();
          });
      });
    }
  }

  borrarFoto(indexABorrar: number, temporal: boolean = false) {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres borrar esta foto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if (!temporal) {
          this.perfil.fotos = this.perfil.fotos.filter(
            (_: any, index: number) => index !== indexABorrar
          );
        } else {
          this.selectedFiles.imagenes = this.selectedFiles.imagenes.filter(
            (_: any, index: number) => index !== indexABorrar
          );
          this.selectedFiles.previewUrl = this.selectedFiles.previewUrl.filter(
            (_: any, index: number) => index !== indexABorrar
          );
        }
      } else {
      }
    });
  }

  cancelar() {
    this.app.editandoperfil=false;
  }

  guardarPerfil(refresh: boolean = false) {
    this.loader.show();
    this.subirScroll();
    this.query.query('misdatos', 'SAVE', this.perfil).subscribe((resultado:any) => {
      const llamadas: any[] = [];
      if (this.perfil.data != null && this.perfil.data != '') {
        const formData = new FormData();
        formData.append('data', this.perfil.data);
        formData.append('principal', 'X');
        formData.append('tipo', 'PE');
        formData.append('tipo_id', '0');
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        llamadas.push(this.http.post(GlobalConstants.urlServer + 'backend/api/upload.php', formData, { headers }));
      }      
      if (this.selectedFiles.imagenes.length > 0) {
        for (const imagen of this.selectedFiles.imagenes) {
          const formData = new FormData();
          formData.append('data', imagen);
          formData.append('principal', '');
          formData.append('tipo', 'PE');
          formData.append('tipo_id', '0');
          const token = localStorage.getItem('token');
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          llamadas.push(this.http.post(GlobalConstants.urlServer + 'backend/api/upload.php', formData, { headers }));
        }
      }
      if (llamadas.length == 0) {
        if (refresh) {
          window.location.reload();
        } else {
          this.app.getMisDatos();
          this.loader.hide();
          this.app.editandoperfil = false;
        }
      }
      // Convertir array → objeto para evitar deprecación
      const llamadasObj = llamadas.reduce((acc, obs, i) => {
        acc[i] = obs;
        return acc;
      }, {} as { [key: string]: any });

      forkJoin(llamadasObj).subscribe(resultados => {    
        if (refresh) {
          window.location.reload();
        } else {
          this.app.getMisDatos();
          this.loader.hide();
          this.app.editandoperfil = false;
        }
      });
    });
  }

  subirScroll() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

}
